import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";

// Ref: Define props for routes
// https://single-spa.js.org/docs/layout-definition#html
const data = {
  loaders: {},
  props: {
    redirectPath: "/pipeline",
    useRelativeP3xUrls: true,
  },
};

const routes = constructRoutes(
  document.querySelector("#single-spa-layout"),
  data
);

// section - map routes to session storage for analytics MFE to use
try {
  const applicationsToIgnore = [
    '@solarmosaic-mfe/header',
    '@solarmosaic-mfe/contract-header',
    '@solarmosaic-mfe/footer',
    '@solarmosaic-mfe/analytics',
    '@solarmosaic-mfe/session'
  ];
  
  const mapNestedRoutes = (routes, parentPath = '/', agg = []) => {
    routes.forEach((route) => {
      if (route.type === 'application') {
        if (applicationsToIgnore.includes(route.name)) return;
        const rtn = { path: parentPath, application: route.name };
        agg.push(rtn);
      } else if (route['routes']) {
        const nextPath = route.path ? (parentPath === '/' ? `/${route.path}` : `${parentPath}/${route.path}`) : parentPath
        mapNestedRoutes(route.routes, nextPath, agg);
      }
    });
  };
  
  const singleSpaRoutes = []
  const main = routes.routes[0];
  main['routes'].forEach((route) => {
    if (route.routes?.length) mapNestedRoutes(route.routes, route.path, singleSpaRoutes);
  });
  sessionStorage.setItem('single-spa-routes', JSON.stringify(singleSpaRoutes));
} catch (e) {
  console.warn('Failed to map single-spa-routes to session storage');
}
// end section

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();
start();
